<template>
  <div class="grabpage">
    <div class="container-top">
      <div class="search">
        <div>
          <span>询单号:</span>
          <el-input size="mini" v-model="inquiryNumber" placeholder="请输入询单号"></el-input>
          <button>查询</button>
        </div>
      </div>
      <div class="redio-list">
        <el-radio-group v-model="radioType">
          <el-radio label="0">全部</el-radio>
          <el-radio label="1">可抢的</el-radio>
          <el-radio label="2">已抢等待结果</el-radio>
          <el-radio label="3">我抢到的</el-radio>
          <el-radio label="4">被抢走的</el-radio>
        </el-radio-group>
      </div>
    </div>
    <el-card class="container-bottom">
      <el-table :header-cell-style="{ color: '#000000' }" ref="tableData" :data="tableData" style="width: 100%">
        <el-table-column width="50">
          <template><i class="el-icon-arrow-right"></i></template>
        </el-table-column>
        <el-table-column align="center" label="询单号" width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 1">
              <span style=" display: inline-block;  height: 20px; background-color: #f3afb9; width: 61px; text-align: center;
                line-height: 19px;border-radius: 5px;color: #fff;">私家团</span><br />
            </p>
            <!-- 企业团样式 -->
            <p v-else>
              <span style="display: inline-block;height: 20px;border: 1px solid #f3afb9; width: 61px;text-align: center;
                line-height: 19px;border-radius: 5px;color: rgb(243, 175, 185);">企业团</span><br />
            </p>
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <!-- 询单人 -->
        <el-table-column height="40" align="center" label="询单人" width="150">
          <template slot-scope="scope">
            <!-- 上下结构 -->
            <span>
              <!-- 头像 -->
              <span style="width: 33px;transform: translateY(6px);text-align: center;line-height: 33px;display: block;float: left;
                height: 33px; border-radius: 20px;">
                <img style="border-radius: 20px; width: 100%; height: 100%" :src="scope.row.createUserImage" alt="" />
              </span>
              <!-- 创建人信息 -->
              <span style="display: flex; flex-direction: column">
                <!-- 名字 -->
                <el-tooltip v-if="scope.row.createName" class="item" effect="dark" :content="scope.row.createName" placement="top">
                  <span style="height: 23px; color: #e96237; font-weight: bold">{{ scope.row.createName }}</span>
                </el-tooltip>
                <span v-else style="height: 23px; color: #e96237; font-weight: bold">{{ scope.row.createName }}</span>
                <!-- 公司 -->
                <el-tooltip v-if="scope.row.createCompanyName" class="item" effect="dark" :content="scope.row.createCompanyName" placement="bottom">
                  <span  style=" height: 23px; overflow: hidden; white-space: nowrap;text-overflow: ellipsis;color: #e96237;
                      font-weight: bold; ">{{ scope.row.createCompanyName }}</span>
                </el-tooltip>
                <span  v-else style="height: 23px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;
                    color: #e96237;font-weight: bold;" >{{ scope.row.createCompanyName }}</span >
              </span>
            </span>
            <!-- 电话 -->
            <span v-if="scope.row.telephone != '' && scope.row.status == 1"
              style=" background: url(../../../static/resource/images/phonebackground.jpg); background-size: 100%; width: 131px;
                height: 30px;display: block;font-weight: bold; line-height: 30px; ">&nbsp; &nbsp; &nbsp;{{ scope.row.telephone }}
            </span>
          </template>
        </el-table-column>
        <!-- 下单时间 -->
        <el-table-column width="150" align="center" label="下单时间">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.createTime }}</span> -->
            <span>{{ dateFormatYMDHM(scope.row.createTime,"-") }}</span>
            <!-- <br><span>{{scope.row.time1}}</span> -->
          </template>
        </el-table-column>
        <!-- 出发地 -->
        <el-table-column align="center" prop="departurePlace" label="出发地">
        </el-table-column>
        <!-- 目的地 -->
        <el-table-column align="center" prop="destination" label="目的地">
        </el-table-column>
        <!-- 预估出行时间 -->
        <el-table-column align="center" width="150" prop="estimatedTravelStart" label="预估出行时间">
          <template slot-scope="scope" v-if="scope.row.inquiryMaintainList[0]">
            <span v-if="scope.row.inquiryMaintainList[0].estimatedTravelStart">{{dateFormatYMD(scope.row.inquiryMaintainList[0].estimatedTravelStart,"-")}}</span><br v-if="scope.row.inquiryMaintainList[0].estimatedTravelEnd" />
            <span v-if="scope.row.inquiryMaintainList[0].estimatedTravelEnd">~</span><br />
            <span v-if="scope.row.inquiryMaintainList[0].estimatedTravelEnd">{{dateFormatYMD(scope.row.inquiryMaintainList[0].estimatedTravelEnd,"-")}}</span>
            <a v-if="scope.row.planNumber&&scope.row.planNumber !== ''" class="see-plan">查看行程</a>
          </template>
        </el-table-column>
        <!-- 预估出行人数  -->
        <el-table-column align="center" label="预估出行人数">
          <template slot-scope="scope">
            <!-- 私家团 -->
            <p v-if="scope.row.type == 1">
              <span style="display: inline-block;height: 20px;background-color: #eb7549;width: 61px;text-align: center;line-height: 19px;
                border-radius: 5px;color: #fff;"> 私家团</span><br />
              <span v-if="scope.row.inquiryMaintainList[0]">{{ scope.row.inquiryMaintainList[0].estimatedTravelAdultNum }}成人</span>
              <span v-if="scope.row.inquiryMaintainList[0]">{{ scope.row.inquiryMaintainList[0].estimatedTravelAdultChildren }}儿童</span>
            </p>
            <!-- 企业团 -->
            <p v-if="scope.row.type == 2">
              <span style="display: inline-block;height: 20px;border: 1px solid #eb7549;width: 61px; text-align: center;line-height: 19px;
                border-radius: 5px;color: rgb(243, 175, 185); ">企业团</span><br />
              <span v-if="scope.row.inquiryMaintainList[0]">{{ scope.row.inquiryMaintainList[0].estimatedTravelAdultNum }}成人</span>
              <span v-if="scope.row.inquiryMaintainList[0]">{{ scope.row.inquiryMaintainList[0].estimatedTravelAdultChildren }}儿童</span>
            </p>
          </template>
        </el-table-column>
        <!-- 预估人均预算 -->
        <el-table-column align="center" prop="price" label="预估人均预算">
          <template slot-scope="scope" v-if="scope.row.inquiryMaintainList[0]">
            <span>{{ scope.row.inquiryMaintainList[0].price }}</span><br />
            <span v-if="scope.row.inquiryMaintainList[0].type == 0">不含机票</span>
            <span v-if="scope.row.inquiryMaintainList[0].type == 1">含经济舱</span>
            <span v-if="scope.row.inquiryMaintainList[0].type == 2">含公务/头等舱</span>
          </template>
        </el-table-column>
        <!-- 预估所需代订项目 -->
        <el-table-column width="150" label="预估所需代订项目">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.needService">
              <span>{{ scope.row.needService }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 期待及主题 -->
        <el-table-column prop="planExpect" label="期待及主题">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.planExpect">
              <span>{{ scope.row.planExpect }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 别的要求 -->
        <el-table-column prop="customerMessage" label="别的要求"></el-table-column>
        <!-- 抢单截至时间 -->
        <el-table-column align="center" width="150" label="操作" fixed="right">
          <template slot-scope="scope">
            <span style="font-weight: bold"></span><br />
            <!-- 按钮 -->
            <span style=" display: flex; justify-content: center;align-items: center; ">             
              <el-popover popper-class="popper-self" v-if="scope.row.status == 0" :ref="`popover-${scope.row.id}`"
                visible-arrow v-model="scope.row.clonepopovershow" offset="-70" placement="left" width="350" trigger="manual">
                <!-- 关闭按钮还未添加清除数据todo -->
                <i @click="scope.row.clonepopovershow = false" style=" font-size: 25px; position: absolute; top: 5px; right: 5px;color: #000;
                  " class="el-icon-circle-close" ></i>
                <!-- 确认抢单 -->
                <span @click="Confirmorder(scope.row)" style="font-size: 15px;cursor: pointer; color: #fff;line-height: 38px;background: #e65019;
                  width: 103px;height: 38px; text-align: center; display: block;margin: 50px auto; font-weight: bold;">
                  确认抢单
                </span>
                <span style=" line-height: 25px; display: inline-block;padding: 0px 0px 0px 28px;">
                  <p style="text-align: left">抢单后请关注，状态变化。</p>
                  <p style="text-align: left; margin-bottom: 15px">
                    如变成“我抢到啦！”则恭喜您已抢单成功！
                  </p>
                  <p style="text-align: left">
                    请点击<span style="margin: 5px 10px;transform: translateX(25px);padding: 6px 18px;background: rgb(255, 114, 114);
                    line-height: 30px;color: rgb(255, 255, 255); border-radius: 5px;box-shadow: rgb(0 0 0 / 40%) 0px 2px 6px 0px;"
                    >抢到啦！</span>查看客人联系方式
                  </p>
                  <p style="text-align: left">
                    并在规定时间内和客人首呼，补充团队信息，
                  </p>
                  <p style="transform: translateY(-10px);text-align: left; margin-bottom: 30px;">
                    并在我抢到了的单内查看及制作方案
                  </p>
                </span>
                <span slot="reference" @click="showConfirm(scope.row)" style="cursor: pointer; display: block;font-size: 20px;
                  background: #e64a19;height: 37px;width: 37px;text-align: center; line-height: 37px;color: #fff;border-radius: 20px;
                  box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 40%);">抢</span>
              </el-popover>
              <span v-if="scope.row.status == 2">哎呀~手慢了~被抢走了</span>
              <span v-if="scope.row.status == 5">已转询</span>
              <!-- 手慢了~ -->
            </span>
            <p @click="grabbedit(scope.row)" v-if="scope.row.status == 1||scope.row.status == 4" style=" margin: 5px 0; transform: translateX(25px);
              display: block;width: 80px; height: 30px; background: #ff7272;text-align: center;line-height: 30px;
              color: #fff;border-radius: 5px;cursor: pointer; box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 40%);">
              点击联系客户
            </p>
            <p @click="transferInquiry(scope.row)" v-if="scope.row.status == 4" style=" margin: 5px 0; transform: translateX(25px);
              display: block;width: 40px; height: 30px; background: #ff7272;text-align: center;line-height: 30px;
              color: #fff;border-radius: 5px;cursor: pointer; box-shadow: 0px 2px 6px 0px rgb(0 0 0 / 40%);">
              转询
            </p>
            <!-- 取消询单 -->
            <span v-if="scope.row.condition == 1">客户好残忍<br />取消询单了呢~</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 私家团抢到了弹出框0 -->
    <div class="ordershowcard" v-show="grabbeditdata.grabbeditshow == true">
      <i @click="clonsegrabbedit" style=" font-size: 25px; position: absolute; top: 5px; right: 5px; color: #000;"
        class="el-icon-circle-close"></i>
        <!-- 内容主体部分 -->
        <div class="ordershowcard-content">
          <span>恭喜您! 订单抢到了哦~~ </span>
          <span style="margin-left: 2px">请尽快和客户联系。</span>
          <p style="margin: 10px 0;color: rgb(230, 80, 25);font-size: 16px;font-weight: bold;">
            客户电话：{{ grabbeditdata.telephone }}
          </p>
          <p style="margin-bottom: 17px">
            客户希望最多<span style="font-size: 16px; font-weight: bold">{{ grabbeditdata.customizerNumber}}</span>
            位定制师为其服务，您联系客户的速度、制作方案的速度、质量、以及价格,会很大程度上影响客户的最终选择~~
          </p>
          <!-- 内容主体部分信息 -->
          <!-- height: 510px; -->
          <div style="background: #f7f7f7">
            <div>
              <p style="display: inline-block;margin-top: 28px;padding-bottom: 10px;border-bottom: 1px solid #ccc;">
                <span style="display: inline-block;height: 20px;background-color: #eb7549; width: 61px;margin: 0 10px;margin-right: 15px;
                  text-align: center;line-height: 20px;border-radius: 5px;color: #fff;" v-if="grabbeditdata.type==1">私家团</span>
                <span style=" display: inline-block;height: 20px; border: 1px solid #f3afb9;width: 61px;text-align: center;
                  margin: 0 10px;line-height: 20px;border-radius: 5px;color: rgb(243, 175, 185);" v-else> 企业团</span>
                <span>客户沟通后信息更新：</span>
              </p>
              <!-- 客户Email： -->
              <p style="margin: 0 10px">
                <span style=" width: 80px;margin: 10px;font-weight: bold; display: inline-block;">客户Email：</span>
                <span  v-show=" grabbeditdata.inquiryMaintainList[0].email != ''&&grabbeditdata.customerdatashow == false"  
                  style="font-weight: bold">{{ grabbeditdata.inquiryMaintainList[0].email }}</span>
                <span v-show="grabbeditdata.customerdatashow == true">
                  <el-input placeholder="请输入客户的电子邮箱" style="width: 230px" size="mini" v-model="grabbeditdata.inquiryMaintainList[0].email"></el-input>
                </span>
                <span  @click="adjustmentcustomerdata()" style=" cursor: pointer;line-height: 25px;float: right; margin-right: 15px;
                  color: #e65019;font-weight: bold;">调整</span>
              </p>
              <!-- 客户电话2： -->
              <p style="margin: 0 10px">
                <span style="width: 80px;margin: 10px; font-weight: bold;display: inline-block;">备用电话：</span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].standbyTelephone != '' &&grabbeditdata.customerdatashow == false" style="font-weight: bold"
                  >{{ grabbeditdata.inquiryMaintainList[0].standbyTelephone }}</span>
                <span v-show=" grabbeditdata.customerdatashow == true">
                  <el-input placeholder="请输入客户的电话号码" style="width: 230px" v-model="grabbeditdata.inquiryMaintainList[0].standbyTelephone" size="mini"></el-input >
                </span>
              </p>
              <!-- 联系时间 -->
              <p style="margin: 0 10px">
                <span  style="width: 80px; margin: 10px;font-weight: bold;display: inline-block; ">联系时间：</span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].contactTime != '' &&grabbeditdata.customerdatashow == false" 
                  style="font-weight: bold">{{ grabbeditdata.inquiryMaintainList[0].contactTime }}</span >
                <span v-show="grabbeditdata.customerdatashow == true">
                  <el-input placeholder="请输入你的联系时间"  v-model="grabbeditdata.inquiryMaintainList[0].contactTime" style="width: 230px" size="mini"></el-input>
                </span>
              </p>
              <p style="margin: 0 10px">
                <span style="width: 80px; margin: 10px;font-weight: bold;display: inline-block; ">出发地: </span>
                <span v-show="grabbeditdata.destinationshow == false">
                  <span> {{grabbeditdata.departurePlace}}</span>
                </span>
                <span v-show="grabbeditdata.destinationshow == true">          
                  <city-autocomplete :obj="grabbeditdata.inquiryMaintainList[0].departurePlaceObj" :sizeType="'small'"></city-autocomplete>
                </span>
                <span @click="adjustmentdestination()" style=" line-height: 25px;float: right; margin-right: 15px; color: #e65019;
                  font-weight: bold;">调整</span>
              </p>
              <!-- 目的地 -->
              <p style="margin: 0 10px">
                <span style="width: 80px; margin: 10px;font-weight: bold;display: inline-block; ">目的地: </span>
                <span v-show="grabbeditdata.destinationshow == false">
                  <span v-for="(item,index) in grabbeditdata.inquiryMaintainList[0].destinationObj" :key="index">
                    {{item.cityName}}
                  </span>
                </span>
                <span v-show="grabbeditdata.destinationshow == true">          
                  <span>
                    <el-tag v-for="(tag,ind) in grabbeditdata.inquiryMaintainList[0].destinationObj" :key="ind" style="margin-right: 5px;"
                    closable @close="handleClose(grabbeditdata.inquiryMaintainList[0].destinationObj,ind)" size="small">{{tag.cityName}}</el-tag>
                  </span>
                  <city-autocomplete :width="'    margin-left: 5px;width:94px'" :obj="grabbeditdata" :sizeType="'small'" :action="false" @handleSelect="handleSelect"></city-autocomplete>
                </span>
                <span @click="adjustmentdestination()" style=" line-height: 25px;float: right; margin-right: 15px; color: #e65019;
                  font-weight: bold;">调整</span>
              </p>
              <!-- 预估出行日期 -->
              <p style="margin: 0 10px">
                <span style="width: 80px;margin: 10px;font-weight: bold;display: inline-block;">预估出行日期:</span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].estimatedTravelStart != '' &&grabbeditdata.traveldatashow == false">
                  {{ dateFormatYMD(grabbeditdata.inquiryMaintainList[0].estimatedTravelStart,"-") }}
                  <span v-if="grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd">-</span>
                  {{grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd == ""? "": dateFormatYMD(grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd,"-")}}
                  <span v-if="grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd">
                    {{(grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd / (3600 * 24 * 1000)-
                    grabbeditdata.inquiryMaintainList[0].estimatedTravelStart / (3600 * 24 * 1000))+1}}天</span>
                </span>
                <span v-show="grabbeditdata.traveldatashow == true">
                  <el-date-picker v-model="grabbeditdata.traveldatato" value-format="yyyy-MM-dd" size="mini" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                  </span>
                <span @click="adjustmenttraveldata()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold; ">调整</span>
              </p>
              <!-- 预估出行人数 -->
              <p style="margin: 0 10px">
                <span style=" width: 80px;margin: 10px;font-weight: bold;display: inline-block;">预估出行人数:</span>
                <span v-show=" grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren != null &&grabbeditdata.estimatednumshow == false">
                  {{ grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultNum }}成人{{grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren}}儿童
                </span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren == null ||grabbeditdata.estimatednumshow == true">
                  <el-input-number :min="0" size="mini" v-model="grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultNum"></el-input-number>成人
                  <el-input-number :min="0" size="mini" v-model="grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren"></el-input-number>儿童
                </span>
                <span @click="adjustmentestimatednum()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold;">调整</span>
              </p>
              <!-- 预算 -->
              <p style="margin: 0 10px">
                <span style="width: 80px;margin: 10px; font-weight: bold;display: inline-block; ">预算:</span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].price != null &&grabbeditdata.budgetshow == false">
                  {{ grabbeditdata.inquiryMaintainList[0].price }}/人
                  <span v-if="grabbeditdata.inquiryMaintainList[0].type == 0">不含机票</span>
                  <span v-if="grabbeditdata.inquiryMaintainList[0].type == 1">含经济舱</span>
                  <span v-if="grabbeditdata.inquiryMaintainList[0].type == 2">含公务/头等舱</span>
                </span>
                <span v-show="grabbeditdata.inquiryMaintainList[0].price == null ||grabbeditdata.budgetshow == true"><span>
                  <el-input v-model="grabbeditdata.inquiryMaintainList[0].price"  style="width: 80px" size="mini"></el-input>
                  </span>&nbsp;/人
                  <el-radio style="margin-left: 5px; width: 50px" v-model="grabbeditdata.inquiryMaintainList[0].type" label="0">不含机票</el-radio>
                  <el-radio style="margin-left: 5px; width: 50px" v-model="grabbeditdata.inquiryMaintainList[0].type" label="1">含经济舱</el-radio>
                  <el-radio style="margin-left: 5px; width: 50px" v-model="grabbeditdata.inquiryMaintainList[0].type" label="2">含公务/头等舱</el-radio>
                </span>
                <span @click="adjustmentbudget()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;font-weight: bold;">调整</span>
              </p>
              <!-- 主题 -->
              <p class="checkButtonP" v-if="grabbeditdata.type==1">
                <span>主题:</span>
                <span class="checkButtonSpan" v-show="grabbeditdata.themeshow == false">
                  <span v-for="(item,index) in grabbeditdata.themesplit" :key="index">{{item}}<span v-if="index!=grabbeditdata.themesplit.length-1">、</span></span>
                  <span v-if="grabbeditdata.inquiryMaintainList[0].otherTheme">;{{ grabbeditdata.inquiryMaintainList[0].otherTheme }}</span>
                </span>
                <span class="checkButtonSpan" v-show="grabbeditdata.themeshow == true">
                  <el-checkbox-group style="width: 395px" size="mini" v-model="grabbeditdata.themesplit" >
                    <el-checkbox-button style="margin: 2px;" v-for="theme in themeList" :label="theme" :key="theme">{{ theme }}</el-checkbox-button>
                  </el-checkbox-group>
                  <el-input placeholder="其他主题" size="mini" style="width: 230px;margin-top: 5px;" v-model="grabbeditdata.inquiryMaintainList[0].otherTheme"></el-input>
                </span>
                <span @click="adjustmenttheme()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold; ">调整</span >
              </p>
              <!-- 行程期待 -->
              <p class="checkButtonP" v-if="grabbeditdata.type==1"> 
                <span>行程期待:</span>
                <span class="checkButtonSpan" v-show="grabbeditdata.tripshow == false">
                  <span v-for="(item,index) in grabbeditdata.planExpectsplit" :key="index">{{item}}<span v-if="index!=grabbeditdata.planExpectsplit.length-1">、</span></span>
                  <span v-if="grabbeditdata.otherPlanExpect">;</span>{{ grabbeditdata.otherPlanExpect }}</span>
                <span class="checkButtonSpan" v-show="grabbeditdata.tripshow == true">
                  <el-checkbox-group style="width: 395px" size="mini" v-model="grabbeditdata.planExpectsplit">
                    <el-checkbox-button v-for="trip in expectList" :label="trip" :key="trip">{{ trip }}</el-checkbox-button>
                  </el-checkbox-group>
                  <el-input placeholder="其他期待" size="mini" style="width: 230px;margin-top: 5px;" v-model="grabbeditdata.inquiryMaintainList[0].otherPlanExpect"></el-input>
                </span>
                <span  @click="adjustmenttrip()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold; ">调整</span>
              </p>
              <!-- 所需服务 -->
              <p class="checkButtonP" v-if="grabbeditdata.type==2">
                <span>所需服务:</span>
                <span class="checkButtonSpan" v-show="grabbeditdata.themeshow == false">
                  <span v-for="(item,index) in grabbeditdata.themesplit" :key="index">{{item}}<span v-if="index!=grabbeditdata.themesplit.length-1">、</span></span>
                  <span v-if="grabbeditdata.inquiryMaintainList[0].otherTheme">;{{ grabbeditdata.inquiryMaintainList[0].otherTheme }}</span>
                </span>
                <span class="checkButtonSpan" v-show="grabbeditdata.themeshow == true">
                  <el-checkbox-group style="width: 395px" size="mini" v-model="grabbeditdata.themesplit" >
                    <el-checkbox-button v-for="theme in serviceList" :label="theme" :key="theme">{{ theme }}</el-checkbox-button>
                  </el-checkbox-group>
                  <el-input placeholder="其他主题" size="mini" style="width: 230px;margin-top: 5px;" v-model="grabbeditdata.inquiryMaintainList[0].otherTheme"></el-input>
                </span>
                <span @click="adjustmenttheme()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold; ">调整</span >
              </p>
              <p class="checkButtonP">
                <span>包含项目:</span>
                <span class="checkButtonSpan" v-show="grabbeditdata.expectshow == false">
                  <span v-for="(item,index) in grabbeditdata.needServicesplit" :key="index">{{item}}<span v-if="index!=grabbeditdata.needServicesplit.length-1">、</span></span>
                  <span v-if="grabbeditdata.otherNeedService">;</span>{{ grabbeditdata.otherNeedService }}
                </span>
                <span class="checkButtonSpan" v-show="grabbeditdata.expectshow == true">
                  <el-checkbox-group style="width: 395px" v-if="grabbeditdata.type==1" size="mini" v-model="grabbeditdata.needServicesplit">
                    <el-checkbox-button v-for="trip in projectListOne" :label="trip" :key="trip">{{ trip }}</el-checkbox-button>
                  </el-checkbox-group>
                  <el-checkbox-group style="width: 395px" v-else size="mini" v-model="grabbeditdata.needServicesplit">
                    <el-checkbox-button v-for="trip in projectListTwo" :label="trip" :key="trip">{{ trip }}</el-checkbox-button>
                  </el-checkbox-group>
                  <el-input placeholder="其他期待" size="mini" style="width: 230px;margin-top: 5px;" v-model="grabbeditdata.inquiryMaintainList[0].otherNeedService"></el-input>
                </span>
                <span  @click="adjustmentexpect()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;
                  font-weight: bold; ">调整</span>
              </p>
              <!-- 客户留言 -->
              <p style="margin: 0 10px">
                <span style="width: 80px;margin: 10px;font-weight: bold;display: inline-block; ">客户留言:</span>
                <span v-show="grabbeditdata.expectliushow == false">{{ grabbeditdata.inquiryMaintainList[0].customerMessage }}</span>
                <span v-show="grabbeditdata.expectliushow == true">
                  <el-input v-model="grabbeditdata.inquiryMaintainList[0].customerMessage" placeholder="请您输入你的留言" style="width: 230px" size="mini"></el-input>
                </span>
                <span @click="adjustmentliuexpect()" style="line-height: 25px;float: right;margin-right: 15px;color: #e65019;font-weight: bold;">调整</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 保存按钮 -->
        <span class="ordershowcard-buttom" @click="savetripdata()">保存并在我抢到的方案中制作行程</span>
      </div>
  </div>
</template>

<script>
import Api from '@/components/Api/index.js'
import CityAutocomplete from '../common/cityAutocomplete.vue'
export default {
  components:{CityAutocomplete},
  data(){
    return{
      inquiryNumber:null,
      radioType:null,
      tableData:[],
      grabbeditdata:{
        inquiryMaintainList:[{
          destinationObj:{},
          departurePlaceObj:{
            cityId:null,
            cityName:null
          },
        }],
        themesplit:[],
        planExpectsplit:[],
        needServicesplit:[]
      },
      themeList:["带孩子","带爹娘","好盆友","撒狗粮","仪式感/蜜月","自己玩儿"],
      expectList:["安排紧凑","行程宽松","地标打卡","大快朵颐"],
      serviceList:["公司旅游","团建拓展","会议培训","商务考察","市场推广","国际会议","参展观展","媒体方案","服务人员","邀请函","国外秀场","VI等设计","摄影摄像"],
      projectListOne:["火车/轮船","酒店","包车","景点","美食","导游","签证","当地特色体验","仪式感活动安排","摄影摄像"],
      projectListTwo:["火车/轮船","酒店","包车","景点","美食","导游","签证","当地特色体验","仪式感活动安排","摄影摄像","团建策划","会场租赁","会议服务","会议设备租赁","教授联系","联系拜访/座谈","品牌推广","产品发布","客户答谢","品牌露出材料制作","大会代为注册","大会代为报道","展场租赁","展场搭建","展会设备租赁","活动媒体邀约","媒体发布","活动礼仪","翻译","安保人员","活动保洁","主持人","演出人员","控场/导演","视频剪辑及后期人员","现场服务人员","政府邀请函","商务邀请函","秀票购买及接送","AI设计","活动用图"],
   }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      new Api('inquiry').orderGrabbingPool({page:1,size:10,q:{}}).then(res => {
        if (res.status == 200) {
          this.tableData = res.data.records
          this.tableData.forEach(ee=>{
            var obj = JSON.parse(ee.inquiryMaintainList[0].destination);
            this.$set(ee.inquiryMaintainList[0],'destinationObj',obj)
            ee.destination = obj.map(e=>e.cityName).join(",")
            ee.departurePlace = ee.inquiryMaintainList[0].departurePlace
            if(ee.departurePlace&&ee.departurePlace!=''){
              var place = JSON.parse(ee.departurePlace)
              ee.departurePlace = place.cityName
              this.$set(ee.inquiryMaintainList[0],'departurePlaceObj',place)
            }else{
              this.$set(ee.inquiryMaintainList[0],'departurePlaceObj',this.grabbeditdata.inquiryMaintainList[0].departurePlaceObj)
            }
            ee.needService = JSON.parse(ee.inquiryMaintainList[0].needService).join(",")
            ee.planExpect = JSON.parse(ee.inquiryMaintainList[0].planExpect).join(",")
            ee.customerMessage = ee.inquiryMaintainList[0].customerMessage
            this.$set(ee,'clonepopovershow',false)
          })
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    handleSelect(item){
      this.grabbeditdata.inquiryMaintainList[0].destinationObj.push({
        id:item.id,
        cityName:item.cityNameCn
      })
    },
    transferInquiry(item){
      new Api('inquiry').transferInquiry({id:item.id}).then(res => {
        if (res.status == 200) {
          item.status=5
          this.$message({type:"success",message:"转询成功"})
        }else{
          this.$message({type:"error",message:res.statusText})
          this.getList()
        }
      })
    },
    handleClose(data,indec){
      data.splice(indec, 1)
    },
    showConfirm(data) {
      // 可能他点了这个抢单就不关闭了，先把所有关闭在打开单独
      this.tableData.forEach((item, index) => {
        this.$set(item,'clonepopovershow',false)
      });
      this.$set(data,'clonepopovershow',true)
      this.$nextTick(() => {
        document.getElementById(this.$refs["popover-"+data.id].$refs.popper.id).style.display ="none"
      })
    },
    // 关闭抢到了弹出框
    clonsegrabbedit() {
      this.$set(this.grabbeditdata,'grabbeditshow',false)
    },
    adjustmentcustomerdata() {
      this.$set(this.grabbeditdata,'customerdatashow',true)
    },
    // 调整目的地
    adjustmentdestination() {
      this.$set(this.grabbeditdata,'destinationshow',true)
    },
    // 调整出行日期
    adjustmenttraveldata() {
      this.$set(this.grabbeditdata,'traveldatashow',true)
    },
    // 调整预估人数
    adjustmentestimatednum() {
      this.$set(this.grabbeditdata,'estimatednumshow',true)
    },
    // 调整预算
    adjustmentbudget() {
      this.$set(this.grabbeditdata,'budgetshow',true)
    },
    // 调整主题|期待及主题
    adjustmenttheme() {
      this.$set(this.grabbeditdata,'themeshow',true)
    },
    // 调整行程
    adjustmenttrip() {
      this.$set(this.grabbeditdata,'tripshow',true)
    },
    // 调整期待
    adjustmentexpect() {
      this.$set(this.grabbeditdata,'expectshow',true)
    },
    // 客户留言
    adjustmentliuexpect() {
      this.$set(this.grabbeditdata,'expectliushow',true)
    },
    grabbedit(data) {
      this.grabbeditdata = data;
      this.$set(this.grabbeditdata,'grabbeditshow',true)
      this.$set(this.grabbeditdata,'traveldatato',null)
      this.$set(this.grabbeditdata,'themesplit',JSON.parse(data.inquiryMaintainList[0].theme))
      this.$set(this.grabbeditdata,'planExpectsplit',JSON.parse(data.inquiryMaintainList[0].planExpect))
      this.$set(this.grabbeditdata,'needServicesplit',JSON.parse(data.inquiryMaintainList[0].needService))
      this.setGrabbedData()
    },
    setGrabbedData(){
      //4.修改调整状态
      this.$set(this.grabbeditdata,'customerdatashow',false)
      this.$set(this.grabbeditdata,'destinationshow',false)
      this.$set(this.grabbeditdata,'traveldatashow',false)
      this.$set(this.grabbeditdata,'estimatednumshow',false)
      this.$set(this.grabbeditdata,'budgetshow',false)
      this.$set(this.grabbeditdata,'themeshow',false)
      this.$set(this.grabbeditdata,'tripshow',false)
      this.$set(this.grabbeditdata,'expectshow',false)
      this.$set(this.grabbeditdata,'expectliushow',false)
    },
    savetripdata() {
      this.$router.push({ name: "plan" });
      this.$store.commit("setRightPopupIndex",0)
      this.$store.commit("setRightPopupIndexType",2)
      //3.关闭弹框
      this.grabbeditdata.grabbeditshow = false;
      this.grabbeditdata.inquiryMaintainList[0].destination = JSON.stringify(this.grabbeditdata.inquiryMaintainList[0].destinationObj)
      this.grabbeditdata.inquiryMaintainList[0].departurePlace = JSON.stringify(this.grabbeditdata.inquiryMaintainList[0].departurePlaceObj)
      if(this.grabbeditdata.traveldatato){
        this.grabbeditdata.inquiryMaintainList[0].estimatedTravelStart = this.grabbeditdata.traveldatato[0]
        this.grabbeditdata.inquiryMaintainList[0].estimatedTravelEnd = this.grabbeditdata.traveldatato[1]
      }
      this.grabbeditdata.inquiryMaintainList[0].theme = JSON.stringify(this.grabbeditdata.themesplit)
      this.grabbeditdata.inquiryMaintainList[0].planExpect = JSON.stringify(this.grabbeditdata.planExpectsplit)
      this.grabbeditdata.inquiryMaintainList[0].needService = JSON.stringify(this.grabbeditdata.needServicesplit)
      this.grabbeditdata.inquiryMaintainList[0].isSend = this.grabbeditdata.isUser
      this.setGrabbedData()
      new Api('inquiry').updateInquiryMaintain(this.grabbeditdata.inquiryMaintainList[0]).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"修改成功"})
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
     // 确认抢单调用的函数
    Confirmorder(data) {
      new Api('inquiry').grabbOrder({informationId:data.id}).then(res => {
        if (res.status == 200) {
          data.status = 1
          this.$message({type:"success",message:"抢单成功"})
        }else{
          this.$message({type:"error",message:res.statusText})
          this.getList()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.grabpage{
  width: 17rem;
  margin: 0 auto;
  .container-top{
    height: 1rem;
    display: flex;
    align-items: center;
    .search{
      color: #101010;
      font-weight: 400;
      flex: 1;
      display: flex;
      justify-content: center;
      >div{
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f7f7f7;
        height: 0.5rem;
        width: 80%;
        padding: 0 0.1rem;
        >span{
          font-weight: 600;
        }
        >div{
          width: 2rem;
        }
        >button{
          font-size: 16px;
          color: #fff;
          background: #e8a38b;
          width: 0.63rem;
          height: 0.38rem;
          border: none;
        }
      }
    }
    .redio-list{
      text-align: center;
      flex: 2;
    }
  }
  .container-bottom{
    
  }
}
.checkButtonP{
  margin: 10px 10px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  >span:first-child{
    width: 80px;
    margin: 0 10px;
    font-weight: bold;
    display: inline-block;
  }
  .checkButtonSpan{
    width: 390px;
    display: inline-block;
  }
}
/deep/ .el-checkbox-button{
  margin: 2px;
}
.ordershowcard {
  position: fixed;
  width: 670px;
  max-height: 600px;
  overflow-y: auto;
  top: 100px;
  right: 160px;
  background: #fff;
  // height: 799px;
  z-index: 10;
  border: 3px solid red;
  //   内容
  .ordershowcard-content {
    // height: 665px;
    // background: beige;
    margin: 41px 46px 10px;
  }
  //   按钮
  .ordershowcard-buttom {
    cursor: pointer;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
    margin: 0 auto;
    font-weight: bold;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    // transform: translateY(-15px);
    margin-bottom: 10px;
    height: 47px;
    width: 292px;

    img {
      margin: 0px 5px;
      width: 33px;
      height: 33px;
      transform: translateY(0px);
    }
  }
}
</style>